export interface NcpAvatar {
    id: number;
    title: string;
    text: string;
    isManual?: boolean;
    imageBase64?: string;
    status?: number | null;
    errorMessage?: string | null;
    isEditing?: boolean;
    isGeneratingPreview?: boolean;
    draftTitle?: string;
    draftText?: string;
}

export enum NcpParseStatus {
    Queued = 1,
    Generating = 2,
    Ready = 3,
    Failed = 4
}

export interface NcpAvatarCategoryResponse {
    avatarSortingTypeId: number;
    promptText: string;
    ncpAvatars: NcpAvatar[];
    parseStatusId: number;
    parseError: string | null;
}

export interface NcpAvatarCategoryListItem {
    avatarSortingTypeId: number;
    promptText: string;
    ncpAvatarCount: number;
    parseStatusId: number;
    parseError: string | null;
    previewCount: number;
    manualCount: number;
}

export interface NcpAvatarCard {
    id: number;
    title: string;
    avatarSortingTypeId: number | null;
    imageBase64: string;
    created?: string;
    genericPrompt?: string | null;
}

export enum NcpBatchStatus {
    Queued = 1,
    Generating = 2,
    Completed = 3
}

export enum NcpItemStatus {
    Pending = 1,
    Generating = 2,
    Generated = 3,
    Failed = 4
}

export interface NcpAvatarBatchItem {
    id: number;
    ncpAvatarCardId: number;
    statusId: number;
    errorMessage: string | null;
}

export interface NcpAvatarBatch {
    id: number;
    dealId: number | null;
    statusId: number;
    totalCount: number;
    items: NcpAvatarBatchItem[];
}
